import { useMemo, useState } from 'react';
import { TabItem } from '../types';
import ControlTab from './ControlTab';
import dynamic from 'next/dynamic';

const Icon = dynamic(() => import('../../../elements/Icon')) as any;

export interface ControlTabsProps {
  activeTab: string;
  onTabChange: (tabId: string) => void;
  type?: 'text' | 'icon';
  tabs: TabItem[];
}

const getTabPosition = (i: number, l: number) =>
  i === l ? 'last' : i === 1 ? 'first' : 'middle';

export const ControlTabs = ({
  tabs,
  activeTab,
  onTabChange,
  type = 'text',
}: ControlTabsProps) => {
  const [active, setActive] = useState(() => activeTab);

  const styles = useMemo(() => {
    return `flex ${type === 'icon' ? 'w-auto' : ''} font-semibold text-xs`;
  }, [type]);

  return (
    <nav>
      <ul className={styles}>
        {tabs.map((tab, i) => (
          <ControlTab
            disabled={tab.disabled}
            key={tab.id}
            onClick={() => {
              setActive(tab.id);
              onTabChange(tab.id);
            }}
            active={active === tab.id}
            type={type}
            position={getTabPosition(i + 1, tabs.length)}
          >
            {type === 'icon' && tab.icon ? (
              <Icon name={tab.icon} aria-label={tab.label} />
            ) : (
              tab.label
            )}
          </ControlTab>
        ))}
      </ul>
    </nav>
  );
};

export default ControlTabs;
